export enum TransitionStates {
  IN = 'in',
  OUT = 'out',
  VOID = 'void'
}
